module.exports = __webpack_public_path__ + "static/media/ordenha_manual.9ebf0edf.jpg";